<template>
    <div></div>
</template>
<script>
export default{
    data() {
        return {
          Authorization:this.$route.query.Authorization
        }
    },
    mounted() {
        sessionStorage.setItem('Authorization',this.Authorization);
        this.$Http_Post('User/GetLogin',{}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          let UserActive = res.Data.UserActive;
          if (UserActive == 0) {//未激活
            this.Global.SourceNo = res.Data.SourceNo;
            this.Global.openInterview = res.Data.openInterview;
            this.Global.haveInterview = res.Data.Flag;
            this.Global.DeptName = res.Data.DeptName;
            this.Global.TeachName = res.Data.TeachName;
            this.Global.TrainName = res.Data.TrainName;
            this.$store.commit('setToken', res.Data.token);
            this.$Http_Post('DepartMent/GetDeptmentByNodeAPP', { DeptID: '', content: '' }).then((res) => {
              if (res.Code == 0 && res.Data) {
                let dataList = res.Data;
                if (dataList.length > 0) {
                  for (let i = 0; i < dataList.length; i++) {
                    if (dataList[i].children.length > 0)
                      this.SetChildrenNode(dataList[i]);
                    else dataList[i].children = undefined;
                  }
                }
                this.data = dataList;
                // this.DeptIDs=this.getParentsById(dataList,this.DeptIDs);
              }
            })
          } else if (UserActive == 2) {//已激活
            sessionStorage.setItem('xinxi', JSON.stringify(res.Data));
            this.Global.SourceNo = res.Data.SourceNo;
            this.Global.openInterview = res.Data.openInterview;
            this.Global.haveInterview = res.Data.Flag;
            this.Global.DeptName = res.Data.DeptName;
            this.Global.TeachName = res.Data.TeachName;
            this.Global.TrainName = res.Data.TrainName;
            if (res.Data.roleDj == '2') {
              sessionStorage.setItem('entity', '管理员');
            } else if (res.Data.roleDj == '5') {
              sessionStorage.setItem('entity', '辅导员');
            } else if (res.Data.roleDj == '3') {
              sessionStorage.setItem('entity', '咨询师');
            } else if (res.Data.roleDj == '4') {
              if(res.Data.RoleID == '1065'  ){
                sessionStorage.setItem('entity', '校长');
              }else{
                sessionStorage.setItem('entity', '来访者');
              }
            } else if (res.Data.roleDj == '1') {
              sessionStorage.setItem('entity', '超级管理员');
            }
            sessionStorage.setItem('RoleID', res.Data.RoleID);
            this.$store.commit('setToken', res.Data.token);
            this.$store.commit('login', res.Data);
            this.Global.birthday = res.Data.Birthday;
            this.Global.userID = res.Data.UserID;
            this.Global.realName = res.Data.RealName;
            this.Global.identity = res.Data.Show;
            this.Global.headPhoto = res.Data.HeadPhoto;
            this.Global.roletype = res.Data.roleDj == '2' ? '管理员' : res.Data.roleDj == '3' ? '咨询师' : res.Data.roleDj == '4' ? '来访者' : '超级管理员';
            this.$message({ message: this.$t('original.languages2'), type: 'success' });
            this.$Http_Post('User/GetMenuButton').then((res) => {
              if (res.Code == 200 || res.Code == 0) {
                sessionStorage.setItem('UserGetMenuButton', JSON.stringify(res.Data));
                this.$router.push('/views');
              }
            })
          } else if (UserActive == 1) {//审批中
            this.dialogVisible2 = true;
            this.dialogVisible = false;
          }
        } else {
          this.$message.error(res.Message);
        }
      })
    },
    methods: {
        
    },
}
</script>